import { Component, OnInit } from '@angular/core';
import { MatCardTitle, MatCard } from "@angular/material/card";
import { MatDivider } from "@angular/material/divider";
import { ThemePalette } from '@angular/material/core';
import { Region } from '../model/resolve-ssid-counts';
import { MatTableDataSource } from '@angular/material/table';
import { CalpadSSIDResoultion } from '../service/calpad-ssid-resolution';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { Router } from '@angular/router';


@Component({
  selector: 'app-resolve-ssid',
  templateUrl: './resolve-ssid.component.html',
  styleUrl: './resolve-ssid.component.scss'
})
export class ResolveSSIDComponent implements OnInit {

  msg: MsgModel = {};
  isLoading: boolean = true;
  tableDataSource: MatTableDataSource<Region> = new MatTableDataSource<Region>();
  results: Region[] = [];
  displayedColumns: string[] = ['Region', 'Unresolved', 'Resolved'];

  constructor(
    private calpadSSIDResoultion: CalpadSSIDResoultion,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.init();
  }

  init() {
    this.calpadSSIDResoultion.getOverallCounts().subscribe((res) => {

      this.results = res['regions'];
      this.tableDataSource.data = this.results;
      this.isLoading = false;
      if (this.results.length <= 0) {
        this.results = [];
        this.msg = { SUCCESS: false, MSG: 'No Records ' };
      }
      else {
        this.msg = { SUCCESS: true, MSG: 'Records Found ' + this.results.length };
      }

    });
  }
  navigateToResolved(code: string, count: string) {
    this.router.navigate(['/children/resolve-ssid/resolved',code] );
  }
  navigateToUnresolved(code: string, count: string) {
    this.router.navigate(['/children/resolve-ssid/unresolved',code]);
  }
}
